import styles from './Badge.module.css';

type Variant = 'green' | 'blue' | 'amber' | 'red' | 'purple' | 'gray';

interface BadgeProps {
  variant: Variant;
  children: React.ReactNode;
}

export function Badge({ variant, children }: BadgeProps) {
  return (
    <span className={`${styles.badge} ${styles[variant]}`}>
      {children}
    </span>
  );
}
